/**
 * @license Copyright (c) 2014-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
// import '../theme/custom.css';
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat.js";
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold.js';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic.js';
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote.js";
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials.js';
import Heading from '@ckeditor/ckeditor5-heading/src/heading.js';
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';
// import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import Image from "@ckeditor/ckeditor5-image/src/image.js";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption.js";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize.js";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle.js";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar.js";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload.js";
import Indent from '@ckeditor/ckeditor5-indent/src/indent.js';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';

import CKEditorInspector from '@ckeditor/ckeditor5-inspector';
import Link from '@ckeditor/ckeditor5-link/src/link.js';
import RdsLink from './inlineeditor/rdslink.js';
import LinkImage from "@ckeditor/ckeditor5-link/src/linkimage.js";
import DocumentList from '@ckeditor/ckeditor5-list/src/documentlist';
import List from '@ckeditor/ckeditor5-list/src/list.js';
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed.js";
import MediaEmbedCommand from '@ckeditor/ckeditor5-media-embed/src/mediaembedcommand.js'
import MediaEmbedToolbar from "@ckeditor/ckeditor5-media-embed/src/mediaembedtoolbar.js";
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph.js';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice.js';
import Table from "@ckeditor/ckeditor5-table/src/table.js";
import TableColumnResize from "@ckeditor/ckeditor5-table/src/tablecolumnresize.js";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar.js";
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation.js';
import {LivePosition, LiveRange} from 'ckeditor5/src/engine';
import CodeBlock from '@ckeditor/ckeditor5-code-block/src/codeblock.js';
import Blocks from "./blocks/blocks"
import './blocks/custom-image-utils'
import MyImageToolbar from "./blocks/image-toolbar";
import Divider from "./divider/divider";
import ImageAndQuoteBox from "./image-and-quote/image-and-quote-box";
import ImageAndQuoteToolbar from "./image-and-quote/image-and-quote-box-toolbar";
import ImageAndTextBox from "./image-and-text/image-and-text-box";
import ImageAndTextToolbar from "./image-and-text/image-and-text-box-toolbar";
import ImagesAndTextBox from "./images-and-text/images-and-text-box";
import ImagesBox from "./images/images-box";
import ImagesBoxToolbar from "./images/images-toolbar";
import InlineEditor from './inlineeditor/inlineeditor.js';
import MovieAndQuoteBox from "./movie-and-text/movie-and-text-box";
import MovieAndQuoteToolbar from "./movie-and-text/movie-and-text-box-toolbar";
import CustomMovieToolbar from "./movie-and-text/movie-toolbar";
import AnnouncementBox from "./people-announcement/announcement-box";
import AnnouncementBoxToolbar from "./people-announcement/announcement-box-toolbar";
import SectionColorsBox from "./section-colors-box/section-colors-box";
import SectionColorsToolbar from "./section-colors-box/section-colors-toolbar";
import TextBox from "./text/text-box";
import TextBoxToolbar from "./text/text-box-toolbar";
import RdsEditor from './newsletter-custom-editor/rdseditor.js';
import AddSesTagsToLinks from './inlineeditor/ses-tags-link.js';

class NewsletterEditor extends InlineEditor {
}

class EventEditor extends ClassicEditorBase {
}

class NewsEditor extends ClassicEditorBase {
}

// Plugins to include in the build.
NewsletterEditor.builtinPlugins = [
    Bold,
    Essentials,
    Heading,
    Indent,
    Italic,
    RdsLink,
    DocumentList,
    Paragraph,
    TextTransformation,
    PasteFromOffice,
    AddSesTagsToLinks,
];

// Editor configuration.
NewsletterEditor.defaultConfig = {
    licenseKey: process.env.CKEDITOR_LICENSE_KEY || '<KEY_NOT_RESOLVED>',
    toolbar: {
        items: [
            'heading',
            'bold',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'link',
            '|',
            'undo',
            'redo'
        ],
        shouldNotGroupWhenFull: true
    },
    language: 'en',
    heading: {
        options: [
            {
                model: 'heading-2-rds',
                view: {
                    name: 'h2',
                    classes: ['newsletter-typography--heading-1']
                },
                title: 'Heading 1',
                class: 'newsletter-typography--heading-1',
                converterPriority: 'high'
            },
            {
                model: 'heading-3-rds',
                view: {
                    name: 'h3',
                    classes: ['newsletter-typography--heading-2']
                },
                title: 'Heading 2',
                class: 'newsletter-typography--heading-2',
                converterPriority: 'high'
            },
            {
                model: 'quote-s',
                view: {
                    name: 'blockquote',
                    classes: ['newsletter-typography--quotation-s']
                },
                title: 'Quotation S',
                class: 'newsletter-typography--quotation-s',
                converterPriority: 'high'
            },
            {
                model: 'quote-m',
                view: {
                    name: 'blockquote',
                    classes: ['newsletter-typography--quotation-m']
                },
                title: 'Quotation M',
                class: 'newsletter-typography--quotation-m',
                converterPriority: 'high'
            },
            {
                model: 'paragraph',
                view: {
                    name: 'p',
                    classes: ['newsletter-typography--body-s']
                },
                title: 'Body S',
                class: 'newsletter-typography--body-s',
                converterPriority: 'high'
            },
            {
                model: 'body-m-rds',
                view: {
                    name: 'p',
                    classes: ['newsletter-typography--body-m']
                },
                title: 'Body M',
                class: 'newsletter-typography--body-m',
                converterPriority: 'highest'
            }
        ]
    },
    link: {
        addTargetToExternalLinks: true,
        defaultProtocol: 'https://'
    },
    placeholder: 'Type here...'
};

EventEditor.builtinPlugins = [
    Essentials,
    Autoformat,
    Bold,
    Italic,
    BlockQuote,
    // CKFinder,
    Heading,
    Image,
    ImageCaption,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Indent,
    IndentBlock,
    Link,
    List,
    MediaEmbed,
    Paragraph,
    PasteFromOffice,
    Table,
    TableToolbar,
    TextTransformation,
    ImageResize,
    LinkImage
];

EventEditor.defaultConfig = {
    licenseKey: process.env.CKEDITOR_LICENSE_KEY || '',
    toolbar: {
        items: [
            'heading',
            'bold',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'insertTable',
            'mediaEmbed',
            '|',
            'undo',
            'redo'
        ],
        shouldNotGroupWhenFull: true
    },
    image: {
        toolbar: [
            "imageStyle:block",
            "imageStyle:side",
            'imageStyle:inline',
            'imageStyle:wrapText',
            'imageStyle:breakText',
            "|",
            "toggleImageCaption",
            "imageTextAlternative"
        ]
    },
    table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
    },
    language: 'en',
    heading: {
        options: [
            {
                model: 'heading-1-rds',
                view: {
                    name: 'h1',
                    classes: ['article-heading-1']
                },
                title: 'Heading 1',
                class: 'article-heading-1',
                converterPriority: 'high'
            },
            {
                model: 'heading-2-rds',
                view: {
                    name: 'h2',
                    classes: ['article-heading-2']
                },
                title: 'Heading 2',
                class: 'article-heading-2',
                converterPriority: 'high'
            },
            {
                model: 'heading-3-rds',
                view: {
                    name: 'h3',
                    classes: ['article-heading-3']
                },
                title: 'Heading 3',
                class: 'article-heading-3',
                converterPriority: 'high'
            },
            {
                model: 'heading-4-rds',
                view: {
                    name: 'h4',
                    classes: ['article-heading-4']
                },
                title: 'Heading 4',
                class: 'article-heading-4',
                converterPriority: 'high'
            },
            {
                model: 'heading-5-rds',
                view: {
                    name: 'h5',
                    classes: ['article-heading-5']
                },
                title: 'Heading 5',
                class: 'article-heading-5',
                converterPriority: 'high'
            },
            {
                model: 'heading-6-rds',
                view: {
                    name: 'h6',
                    classes: ['article-heading-6']
                },
                title: 'Heading 6',
                class: 'article-heading-6',
                converterPriority: 'high'
            },
            {
                model: 'quote-m',
                view: {
                    name: 'blockquote',
                    classes: ['article-quote-m']
                },
                title: 'Quote M',
                class: 'article-quote-m',
                converterPriority: 'highest'
            },
            {
                model: 'quote-s',
                view: {
                    name: 'blockquote',
                    classes: ['article-quote-s']
                },
                title: 'Quote S',
                class: 'article-quote-s',
                converterPriority: 'high'
            },
            {
                model: 'lead-rds',
                view: {
                    name: 'p',
                    classes: ['article-lead']
                },
                title: 'Lead',
                class: 'article-lead',
                converterPriority: 'high'
            },
            {
                model: 'paragraph',
                view: {
                    name: 'p',
                    classes: ['article-body-s']
                },
                title: 'Body S',
                class: 'article-body-s',
                converterPriority: 'high'
            },
            {
                model: 'body-m-rds',
                view: {
                    name: 'p',
                    classes: ['article-body-m']
                },
                title: 'Body M',
                class: 'article-body-m',
                converterPriority: 'highest'
            }
        ]
    },
    link: {
        addTargetToExternalLinks: true,
        defaultProtocol: 'https://'
    },
    mediaEmbed: {
        elementName: 'oembed',
        extraProviders: [
            {
                name: 'streamingMedia',
                url: [
                    /^(https:\/\/)streamingmedia\.roche\.com\/(.*)/
                ],
                html: match => {
                    const data = match[2].includes('?') ? match[2].split('?')[0].split('/') : match[2].split('/');
                    const params = match[2].includes('?') ? match[2].split('?')[1].split('&') : [];
                    let title;
                    let entryId;
                    let src;
                    switch (data[0]) {
                        // ['media', /TITLE/, /ENTRY_ID/]
                        case 'media': {
                            title = data[1].split('+').join(' ');
                            entryId = data[2];
                            src = `https://streamingmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/55562072`;
                            break;
                        }
                        case 'playlist': {
                            // ['playlist', 'dedicated', /PBC/, /???/, /ENTRY_ID/]
                            title = '';
                            entryId = data[4];
                            src = `https://streamingmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/55562072`;
                            break;
                        }
                        case 'embed': {
                            // ['embed', 'secure', 'iframe', 'entryId', /ENTRY_ID/, 'uiConfId', CONF_ID, 'pbc', /PBC/]
                            title = '';
                            entryId = data[4];
                            src = `https://streamingmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/55562072`;
                            break;
                        }
                    }

                    if (params.length > 0) {
                        params.forEach(param => {
                            src += `/${param.split('=')[0]}/${param.split('=')[0]}`
                        })
                    } else {
                        src += '/st/0'
                    }

                    return (
                        `
						<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe
            id="kmsembed-${entryId}"
            src="${src}"
            style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
            allowfullscreen webkitallowfullscreen mozAllowFullScreen
            allow="autoplay *;fullscreen *; encrypted-media *;  local-network-access *" 
            referrerPolicy="no-referrer-when-downgrade"
            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
            frameborder="0"
            title="${title}"></iframe>
						</div>
            `
                    );
                }
            },
            {
                name: 'learnMedia',
                url: [
                    /^(https:\/\/)learnmedia\.roche\.com\/(.*)/
                ],
                html: match => {
                    const data = match[2].includes('?') ? match[2].split('?')[0].split('/') : match[2].split('/');
                    const params = match[2].includes('?') ? match[2].split('?')[1].split('&') : [];
                    let title;
                    let entryId;
                    let src;
                    switch (data[0]) {
                        // ['media', /TITLE/, /ENTRY_ID/]
                        case 'media': {
                            title = data[1].split('+').join(' ');
                            entryId = data[2];
                            src = `https://learnmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/54728132`;
                            break;
                        }
                        case 'playlist': {
                            // ['playlist', 'dedicated', /PBC/, /???/, /ENTRY_ID/]
                            title = '';
                            entryId = data[4];
                            src = `https://learnmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/54728132`;
                            break;
                        }
                        case 'embed': {
                            // ['embed', 'secure', 'iframe', 'entryId', /ENTRY_ID/, 'uiConfId', CONF_ID, 'pbc', /PBC/]
                            title = '';
                            entryId = data[4];
                            src = `https://learnmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/54728132`;
                            break;
                        }
                    }

                    if (params.length > 0) {
                        params.forEach(param => {
                            src += `/${param.split('=')[0]}/${param.split('=')[0]}`
                        })
                    } else {
                        src += '/st/0'
                    }

                    return (
                        `
						<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe
            id="kmsembed-${entryId}"
            src="${src}"
            style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
            allowfullscreen webkitallowfullscreen mozAllowFullScreen
            allow="autoplay *;fullscreen *; encrypted-media *; local-network-access *" 
            referrerPolicy="no-referrer-when-downgrade"
            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
            frameborder="0"
            title="${title}"></iframe>
						</div>
            `
                    );
                }
            }
        ]
    }
};

// Plugins to include in the build.
NewsEditor.builtinPlugins = [
  Essentials,
  Autoformat,
  Bold,
  Italic,
  BlockQuote,
  // CKFinder,
  Heading,
  Image,
  ImageCaption,
  ImageStyle,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  CodeBlock,
  Link,
  DocumentList,
  MediaEmbed,
  Paragraph,
  PasteFromOffice,
  Table,
  TableToolbar,
  TableColumnResize,
  TextTransformation,
  ImageResize,
  LinkImage,
  HorizontalLine,
  Divider,
  SectionColorsBox,
  SectionColorsToolbar,
  MediaEmbedToolbar,
  Blocks,
  AnnouncementBox,
  AnnouncementBoxToolbar,
  ImageAndTextBox,
  ImageAndTextToolbar,
  ImageAndQuoteBox,
  ImageAndQuoteToolbar,
  MovieAndQuoteBox,
  MovieAndQuoteToolbar,
  TextBox,
  TextBoxToolbar,
  ImagesAndTextBox,
  ImagesBox,
  ImagesBoxToolbar,
  MyImageToolbar,
  CustomMovieToolbar
];

// Editor configuration.
NewsEditor.defaultConfig = {
    licenseKey: process.env.CKEDITOR_LICENSE_KEY || '',
    language: 'en',
    toolbar: {
        items: [
            'heading',
            'bold',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'insertTable',
            'mediaEmbed',
            'codeBlock',
            '|',
            'divider',
            '|',
            'blocks',
            'sectionColorsBox',
            '|',
            'undo',
            'redo'

        ],
        shouldNotGroupWhenFull: true
    },
    image: {
        toolbar: [
            "imageStyle:block",
            "imageStyle:side",
            'imageStyle:inline',
            'imageStyle:wrapText',
            'imageStyle:breakText',
            "|",
            "toggleImageCaption",
            "imageTextAlternative",
            "resizeImage"
        ],
        resizeOptions: [
            {
                name: 'resizeImage:original',
                value: null,
                label: 'Original'
            },
            {
                name: 'resizeImage:33',
                value: '33',
                label: '33%'
            },
            {
                name: 'resizeImage:50',
                value: '50',
                label: '50%'
            },
            {
                name: 'resizeImage:66',
                value: '66',
                label: '66%'
            },
            {
                name: 'resizeImage:100',
                value: '100',
                label: '100%'
            }
        ],
    },

    list: {
        properties: {
            styles: true,
            startIndex: true,
            reversed: true
        }
    },
    table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
    },
    customImage: {
        options: [
            {
                name: 'resizeImage:33',
                value: '33',
                label: '33%'
            },
            {
                name: 'resizeImage:50',
                value: '50',
                label: '50%'
            },
            {
                name: 'resizeImage:66',
                value: '66',
                label: '66%'
            }
        ]
    },
    sectionColorsBox: {
        contentToolbar: ["sectionColorsBox"],
        options: [
            {
                model: '',
            },
            {
                model: 'bg-neutral-dark-colour',
            },
            {
                model: 'bg-neutral-medium-colour',
            },
            {
                model: 'bg-neutral-light-colour',
            },
            {
                model: 'bg-neutral-gradient',
            },
            {
                model: 'bg-neutral-gradient-bottom-right',
            },
            {
                model: 'bg-neutral-gradient-top-left',
            },
            {
                model: 'bg-blue-gradient-top-left',
            },
            {
                model: 'bg-blue-gradient-bottom-right',
            },
            {
                model: 'bg-gradient-white-to-grey',
            },
            {
                model: 'bg-warm-blue-gradient-top-left',
            },
            {
                model: 'bg-warm-blue-gradient-bottom-right',
            }
        ],
    },

    heading: {
        options: [
            {
                model: 'heading-1-rds',
                view: {
                    name: 'h1',
                    classes: ['article-heading-1']
                },
                title: 'Heading 1',
                class: 'article-heading-1',
                converterPriority: 'high'
            },
            {
                model: 'heading-2-rds',
                view: {
                    name: 'h2',
                    classes: ['article-heading-2']
                },
                title: 'Heading 2',
                class: 'article-heading-2',
                converterPriority: 'high'
            },
            {
                model: 'heading-3-rds',
                view: {
                    name: 'h3',
                    classes: ['article-heading-3']
                },
                title: 'Heading 3',
                class: 'article-heading-3',
                converterPriority: 'high'
            },
            {
                model: 'heading-4-rds',
                view: {
                    name: 'h4',
                    classes: ['article-heading-4']
                },
                title: 'Heading 4',
                class: 'article-heading-4',
                converterPriority: 'high'
            },
            {
                model: 'heading-5-rds',
                view: {
                    name: 'h5',
                    classes: ['article-heading-5']
                },
                title: 'Heading 5',
                class: 'article-heading-5',
                converterPriority: 'high'
            },
            {
                model: 'heading-6-rds',
                view: {
                    name: 'h6',
                    classes: ['article-heading-6']
                },
                title: 'Heading 6',
                class: 'article-heading-6',
                converterPriority: 'high'
            },
            {
                model: 'quote-m',
                view: {
                    name: 'blockquote',
                    classes: ['article-quote-m']
                },
                title: 'Quote M',
                class: 'article-quote-m',
                converterPriority: 'high'
            },
            {
                model: 'quote-s',
                view: {
                    name: 'blockquote',
                    classes: ['article-quote-s']
                },
                title: 'Quote S',
                class: 'article-quote-s',
                converterPriority: 'high'
            },
            {
                model: 'lead-rds',
                view: {
                    name: 'p',
                    classes: ['article-lead']
                },
                title: 'Lead',
                class: 'article-lead',
                converterPriority: 'high'
            },

            {
                model: 'body-s-rds',
                view: {
                    name: 'p',
                    classes: ['article-body-s']
                },
                title: 'Body S',
                class: 'article-body-s'
            },
            {
                model: 'paragraph',
                view: {
                    name: 'p',
                    classes: ['article-body-m']
                },
                title: 'Body M',
                class: 'article-body-m'
            }
        ]
    }, 
    link: {
        addTargetToExternalLinks: true,
        defaultProtocol: 'https://',
        decorators: [
            {
                mode: 'automatic',
                callback: url => /^(https?:)?\/\//.test(url),
                attributes: {
                    class: 'rds-link'
                }
            }
        ]
    },
    mediaEmbed: {
        elementName: 'oembed',
        extraProviders: [
            {
                name: 'streamingMedia',
                url: [
                    /^(https:\/\/)streamingmedia\.roche\.com\/(.*)/
                ],
                html: match => {
                    const data = match[2].includes('?') ? match[2].split('?')[0].split('/') : match[2].split('/');
                    const params = match[2].includes('?') ? match[2].split('?')[1].split('&') : [];
                    let title;
                    let entryId;
                    let src;
                    switch (data[0]) {
                        // ['media', /TITLE/, /ENTRY_ID/]
                        case 'media': {
                            title = data[1].split('+').join(' ');
                            entryId = data[2];
                            src = `https://streamingmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/55562072`;
                            break;
                        }
                        case 'playlist': {
                            // ['playlist', 'dedicated', /PBC/, /???/, /ENTRY_ID/]
                            title = '';
                            entryId = data[4];
                            src = `https://streamingmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/55562072`;
                            break;
                        }
                        case 'embed': {
                            // ['embed', 'secure', 'iframe', 'entryId', /ENTRY_ID/, 'uiConfId', CONF_ID, 'pbc', /PBC/]
                            title = '';
                            entryId = data[4];
                            src = `https://streamingmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/55562072`;
                            break;
                        }
                    }

                    if (params.length > 0) {
                        params.forEach(param => {
                            src += `/${param.split('=')[0]}/${param.split('=')[0]}`
                        })
                    } else {
                        src += '/st/0'
                    }

                    return (
                        `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">
						<iframe
            id="kmsembed-${entryId}"
            src="${src}"
            style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
            allowfullscreen webkitallowfullscreen mozAllowFullScreen
            allow="autoplay *;fullscreen *; encrypted-media *; local-network-access *"  
            referrerPolicy="no-referrer-when-downgrade"
            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
            frameborder="0"
            title="${title}"></iframe>
						</div>
            `
                    );
                }
            },
            {
                name: 'learnMedia',
                url: [
                    /^(https:\/\/)learnmedia\.roche\.com\/(.*)/
                ],
                html: match => {
                    const data = match[2].includes('?') ? match[2].split('?')[0].split('/') : match[2].split('/');
                    const params = match[2].includes('?') ? match[2].split('?')[1].split('&') : [];
                    let title;
                    let entryId;
                    let src;
                    switch (data[0]) {
                        // ['media', /TITLE/, /ENTRY_ID/]
                        case 'media': {
                            title = data[1].split('+').join(' ');
                            entryId = data[2];
                            src = `https://learnmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/54728132`;
                            break;
                        }
                        case 'playlist': {
                            // ['playlist', 'dedicated', /PBC/, /???/, /ENTRY_ID/]
                            title = '';
                            entryId = data[4];
                            src = `https://learnmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/54728132`;
                            break;
                        }
                        case 'embed': {
                            // ['embed', 'secure', 'iframe', 'entryId', /ENTRY_ID/, 'uiConfId', CONF_ID, 'pbc', /PBC/]
                            title = '';
                            entryId = data[4];
                            src = `https://learnmedia.roche.com/embed/secure/iframe/entryId/${entryId}/uiConfId/54728132`;
                            break;
                        }
                    }

                    if (params.length > 0) {
                        params.forEach(param => {
                            src += `/${param.split('=')[0]}/${param.split('=')[0]}`
                        })
                    } else {
                        src += '/st/0'
                    }

                    return (
                        `
						<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe
            id="kmsembed-${entryId}"
            src="${src}"
            style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"
            allowfullscreen webkitallowfullscreen mozAllowFullScreen
            allow="autoplay *;fullscreen *; encrypted-media *; local-network-access *" 
            referrerPolicy="no-referrer-when-downgrade"
            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
            frameborder="0"
            title="${title}"></iframe>
						</div>
            `
                    );
                }
            }
        ]
    },
    indentBlock: {
        classes: [
            'ms-6'
        ]
    }
};

export default {
    NewsEditor,
    NewsletterEditor,
    EventEditor,
    RdsEditor,
    MediaEmbedCommand,
    LiveRange,
    LivePosition,
    CKEditorInspector
};
